<template>
  <div id="order-map" class="order-map"></div>
</template>

<script>
export default Vue.component("order-map", {
  props: ["branchLocation", "deliveyAddress", "restLogo", "driverLocation", "driverIcon"],
  data() {
    return {
      egypt: {
        lat: 30.06263,
        lon: 31.24967
      },
      orderMap:null,
      DriverMarker:null,
      numDeltas : 3000, //time frames
      delay : 10, //milliseconds
      //total seconds= numDeltas(3000)*delay(10) => 30,000 milliseconds
      moveIndex : 0,
      deltaLat:null,
      deltaLng:null,
      newPosition:[],
      oldPosition:[],
      flag:true
    };
  },
  methods: {
    transition(){
    this.moveIndex = 0;
    this.deltaLat = (this.newPosition[0] - this.oldPosition[0])/this.numDeltas;
    this.deltaLng = (this.newPosition[1] - this.oldPosition[1])/this.numDeltas;
    this.moveMarker();
    },
    moveMarker(){
      this.oldPosition[0] += this.deltaLat;
      this.oldPosition[1] += this.deltaLng;
      let latlng = new google.maps.LatLng(this.oldPosition[0], this.oldPosition[1]);
      this.DriverMarker.setPosition(latlng);
      if(this.moveIndex!=this.numDeltas){
          this.moveIndex++;
          setTimeout(this.moveMarker, this.delay);
      }      
    },
    getURL(url) {
      return this.$root.updatePhotosURL(
        url,
        this.$root.photosUrlEnum.version.thumbnail
      );
    },
    initMap() {
      this.orderMap = new google.maps.Map(document.getElementById("order-map"), {
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        center: this.deliveyAddress,
        zoom: 13,
        streetViewControl: false
      });

      var bounds = new google.maps.LatLngBounds();

      if (this.deliveyAddress) {
        var address1 = new google.maps.LatLng(this.deliveyAddress.lat, this.deliveyAddress.lng);
        var marker1 = new google.maps.Marker({
          position: address1,
          map: this.orderMap,
          icon: {
            url: "/public/img/delivery.png",
            scaledSize: new window.google.maps.Size(35, 43)
          }
        });
      }
      if (this.branchLocation) {
        var address2 = new google.maps.LatLng(this.branchLocation.lat, this.branchLocation.lng);
        var marker3 = new google.maps.Marker({
          position: address2,
          map: this.orderMap,
          icon: {
            url: this.getURL(this.restLogo),
            scaledSize: new window.google.maps.Size(26, 26),
            size: new window.google.maps.Size(26, 52)
          }
        });
        var marker2 = new google.maps.Marker({
          position: address2,
          map: this.orderMap,
          icon: {
            url: "/public/img/rest-marker.png",
            scaledSize: new window.google.maps.Size(31, 55)
          }
        });
      }
      if (this.driverLocation) {
        var address3 = new google.maps.LatLng(this.driverLocation.lat, this.driverLocation.lng);
        this.DriverMarker = new google.maps.Marker({
          position: address3,
          map: this.orderMap,
          duration: 5000,
          icon: {
            url: '/public/img/scooter-online.png',
            scaledSize: new window.google.maps.Size(30, 25),
          }
        });
      }
      address1 && bounds.extend(address1);
      address2 && bounds.extend(address2);
      address3 && bounds.extend(address3);
      this.orderMap.fitBounds(bounds);
    }
  },
  mounted() {
    this.deliveyAddress &&
      (this.deliveyAddress["lng"] = this.deliveyAddress.lon);
    this.branchLocation &&
      (this.branchLocation["lng"] = this.branchLocation.lon);
    this.driverLocation &&
      (this.driverLocation["lng"] = this.driverLocation.lon);
    this.initMap();
    
  },
  watch: {
    // whenever question changes, this function will run
    driverLocation: function (newLocation, oldLocation) {
      this.driverLocation = newLocation;
      this.driverLocation &&
      (this.driverLocation["lng"] = this.driverLocation.lon);
      if(oldLocation && newLocation && (oldLocation.lat!=newLocation.lat||oldLocation.lon!=newLocation.lon) ){
        this.oldPosition=[]
        this.newPosition=[]
        this.oldPosition.push(oldLocation.lat)
        this.oldPosition.push(oldLocation.lon)
        this.newPosition.push(newLocation.lat)
        this.newPosition.push(newLocation.lon)
        this.transition()
      }
      else{
        if(this.flag){
          this.initMap()
          this.flag=false
        }
      }
      if (!newLocation && this.DriverMarker) {
        this.DriverMarker.setMap(null);
      }

    
    }
  },
});
</script>
<style>
#order-map {
  height: 400px;
}
</style>